import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config';

export default {
  data() {
    return {
      tailwindMixin: {
        config: resolveConfig(tailwindConfig),
        currentWindowWidth: window.innerWidth,
        resizeDebounceTimeout: null,
      },
    };
  },
  computed: {
    doesWindowHaveMinWidthXs() {
      const breakpointWidth = parseInt(
        this.tailwindMixin.config.theme.screens.xs.replace('px', ''),
      );
      return this.tailwindMixin.currentWindowWidth >= breakpointWidth;
    },
    screensize() {
      let size = this.tailwindMixin.currentWindowWidth;
      let windowSize;

      if(size > this.tailwindMixin.config.theme.screens.xl.replace('px', '')) {
        windowSize = 'xl';
      }

      if(size <= this.tailwindMixin.config.theme.screens.xl.replace('px', '')) {
        windowSize = 'lg';
      }

      if(size <= this.tailwindMixin.config.theme.screens.lg.replace('px', '')) {
        windowSize = 'md';
      }

      if(size <= this.tailwindMixin.config.theme.screens.md.replace('px', '')) {
        windowSize = 'sm';
      }

      if(size <= this.tailwindMixin.config.theme.screens.sm.replace('px', '')) {
        windowSize = 'xs';
      }
      return windowSize;
    }
  },
  methods: {
    resizeHandlerForTailwindMixin() {
      clearTimeout(this.tailwindMixin.resizeDebounceTimeout);
      this.tailwindMixin.resizeDebounceTimeout = setTimeout(() => {
        this.tailwindMixin.currentWindowWidth = window.innerWidth;
      }, 500);
    },
  },
  mounted() {
    window.addEventListener('resize', this.resizeHandlerForTailwindMixin);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandlerForTailwindMixin);
  },
};
